export default __webpack_public_path__ + "static/media/leader_notes_detailed.077a2beb.pdf";